import React, { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../../Components/SideBar/sideBar";
import Header from "../../Components/Header/header";
import RestrictedAccountBanner from "../../Components/RestrictedAccountBanner/RestrictedAccountBanner";
import { changeCardFalse } from "../../Redux/store/selectedCard";
import { useDispatch, useSelector } from "react-redux";
import ChatWidgetIframe from "../../Components/Chat/chat-widget";
import useAutoLogout from "../../Components/custom-logout/custom-logout";
import { logout as logoutTokenManager } from "../../Utils/tokenManager";
import { fetchProfileMe } from "../../services/profileService";
import { syncAccountRestriction } from "../../Utils/syncAccountRestriction";
import { clearAccountRestriction } from "../../Redux/store/accountRestrictionSlice";
import { selectCardCurrencyName } from "../../Utils/cardCurrency";

const AdminDashboard = ({ children }) => {
  const [selectedMenuId, setSelectedMenuId] = useState(1);
  const [isMobile, setIsMobile] = useState(
    window.outerWidth <= 768 ? true : false
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const scrollRef = useRef(null);
  const chatRef = useRef(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [hideChat, setHideChat] = useState(false);
  const showPopup = useSelector((state) => state.form.showPopup);
  const cardCurrencyName = useSelector(selectCardCurrencyName);

  useEffect(() => {
    const loadAccountRestriction = async () => {
      try {
        const response = await fetchProfileMe(cardCurrencyName.label);
        if (response.status === 200) {
          syncAccountRestriction(dispatch, response.data);
        }
      } catch (error) {
        console.error("Failed to load account restriction:", error);
      }
    };

    loadAccountRestriction();
  }, [dispatch, cardCurrencyName.label]);
  const logout = () => {
    logoutTokenManager();
    dispatch(clearAccountRestriction());
  };

  useAutoLogout(logout);
  const handleMenuChange = (menuId) => {
    setSelectedMenuId(menuId);

    // Navigate to different routes based on menu selection
    const routes = {
      1: "/",
      2: "/my-profile",
      3: "/my-investments", // Default route
      4: "/investment-hub",
      5: "/inspecie-transfer",
      6: "/my-documents",
      7: "/reports",
      9: "/alerts",
    };
    if (menuId == 1) {
      dispatch(changeCardFalse());
    }
    const targetRoute = routes[menuId];

    let redirectState = {
      path: targetRoute,
      state: {
        from: location.pathname,
      },
    };
    sessionStorage.setItem("redirectAfterLogin", JSON.stringify(redirectState));
    navigate(targetRoute, { state: { from: location.pathname } });
  };
  // Show button after scrolling 100px
  useEffect(() => {
    const handleScroll = () => {
      console.log("I am main scrolling");
      setShowScrollTop(window.scrollY > 60);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    if (!chatRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const isIntersecting = entries.some((entry) => entry.isIntersecting);
        setHideChat(isIntersecting);
      },
      { threshold: 0.1 }
    );

    const attachObservers = () => {
      observer.disconnect();
      const targets = document.querySelectorAll(".bottom-actions-save");
      targets.forEach((el) => observer.observe(el));
    };

    // Attach when popup changes
    attachObservers();

    // Optional: Watch DOM for dynamic additions
    const mutationObserver = new MutationObserver(attachObservers);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [showPopup]); // <-- re-run whenever popup is shown/hidden

  return (
    <div className="flex bg-[#F0F0F0] min-h-screen">
      {location.pathname != "/onboarding" && (
        <Sidebar
          toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
          isMenuOpen={isMenuOpen}
          isMobile={isMobile}
          onSideMenupChange={handleMenuChange}
        />
      )}

      <div
        className={`flex flex-col flex-grow overflow-auto ${
          isMobile
            ? isMenuOpen
              ? "opacity-30 overflow-hidden"
              : "opacity-100"
            : "opacity-100"
        }`}
      >
        {location.pathname != "/onboarding" && (
          <Header
            toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
            isMenuOpen={isMenuOpen}
            isMobile={isMobile}
            currentScreen={location.pathname}
            onBack={() => navigate(location.state?.from || "/")}
          />
        )}
        {location.pathname != "/onboarding" && <RestrictedAccountBanner />}
        {/* need to set footer on the bottom for that we need this content to take full height */}
        <div className="flex flex-col flex-grow overflow-hidden">
          {children}
          <div
            ref={chatRef}
            className={`fixed right-4 z-50  transition-all duration-500 ease-in-out
    ${
      showPopup
        ? "opacity-0 pointer-events-none scale-95"
        : "opacity-100 pointer-events-auto"
    }`}
          >
            <ChatWidgetIframe pathName={location.pathname} />
          </div>
          {showScrollTop && (
            <button
              onClick={scrollToTop}
              className={`
                ${isMobile ? "bottom-[8vh]" : "bottom-[4.5vw]"}
           
              ml-2 h-12 w-12 font-medium fixed right-2 z-50 bg-black text-white px-4 py-2 rounded-full shadow-lg hover:bg-gray-800`}
            >
              ↑
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
